/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const HomeIcon = props => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24.3 22.5'
			width='1em'
			height='1em'
			{...props}
		>
			<path
				className='prefix__st0'
				d='M24 9.6L12.8.2c-.2-.1-.4-.2-.6-.2-.2 0-.5.1-.6.2L.4 9.6c-.4.3-.5.7-.3 1.1.1.4.5.7.9.7h.7v10.1c0 .6.4 1 1 1h18.9c.5 0 1-.4 1-1V11.4h.7c.4 0 .8-.3.9-.7.2-.4.1-.8-.2-1.1zM13.9 21.5h-3.5v-5.3h3.5v5.3zm7.7-11.1v11.1h-6.7v-5.8c0-.3-.2-.5-.5-.5H9.9c-.3 0-.5.2-.5.5v5.8H2.7V10.4H1L12.2 1l11.2 9.4h-1.8z'
			/>
		</svg>
	)
}

export default HomeIcon
